import React, { useState, useEffect } from 'react';
import { MenuItem, FormControl, Select, InputLabel, CircularProgress } from '@mui/material';
import { fetchClients } from '@src/api/actions/clients';

const ClientDropdown = ({ value, onChange }) => {
  const [clients, setClients] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    fetchClients()
      .then((response) => {
        console.log('Clients response:', response);  // Log the full response
        if (response.data && Array.isArray(response.data)) {
          setClients(response.data);
        } else {
          console.error('Invalid response format');
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsError(true);
        setIsLoading(false);
        console.error('Error fetching clients:', error);
      });
  }, []);
  
  if (isLoading) {
    return <CircularProgress />;
  }

  if (isError) {
    return <div>Error loading clients. Please try again later.</div>;
  }

  return (
    <FormControl fullWidth variant="outlined" margin="normal">
      <InputLabel id="client-dropdown-label">Select Client</InputLabel>
      <Select
        labelId="client-dropdown-label"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        label="Select Client"
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {clients.length > 0 ? (
          clients.map((client) => (
            <MenuItem key={client.id} value={client.id}>
              {client.name}
            </MenuItem>
          ))
        ) : (
          <MenuItem value="">
            <em>No clients available</em>
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default ClientDropdown;
